import styled from '@emotion/styled';
import { pepAndSanctionsColors } from 'src/assets/colors';
import { TablePropsType, TableWrapperTemplate, TableHeaderRowTemplate, TableRowTemplate, ColumnHeaderTemplate, TableCellTemplate, SectionMessageTemplate } from 'src/components/FraudAndCompliance/FraudAndCompliancesTab/FraudAndCompliances/components/CommonTable.styles';
import { ChevronDownIcon } from 'src/assets/icons/ChevronDownIcon';
import { Button } from 'src/domains/layouts/shared/buttons/Button';

export const PEPContainer = styled('div', { label: 'PEPContainer' })`
    flex: 1 1 0%;
    height: calc(100vh - 56px);
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0 24px 24px 24px;
`;

export const SectionMessage = styled(SectionMessageTemplate, { label: 'SectionMessage' })``;

export const TableWrapper = styled(TableWrapperTemplate, { label: 'TableWrapper' })``;

export const TableHeaderRow = styled(TableHeaderRowTemplate, { label: 'TableHeaderRow' })``;

export const TableRow = styled(TableRowTemplate, { label: 'TableRow' }) <TablePropsType>`
    height: 50px;
`;

export const ColumnHeader = styled(ColumnHeaderTemplate, { label: 'ColumnHeader' })`
`;

export const TableCell = styled(TableCellTemplate, { label: 'TableCell' }) <{ cellWidth: number, isClickable: boolean }>`
    cursor: ${({ isClickable }): string => isClickable === true ? 'pointer' : 'default'};
    padding: 4px;
    width: ${({ cellWidth }): string => cellWidth !== null ? `${cellWidth}%` : 'auto'} !important;
`;

export const TabWrapper = styled('div', { label: 'TabWrapper' })`
    color: ${pepAndSanctionsColors.mainColor};
    height: auto;
    font-family: sans-serif;
    padding: 15px 0 33px 0;
    position: relative;
    width: 100%;
`;

export const UlInline = styled('ul', { label: 'UlInline' })`
    display: flex;
    margin: 0 0 0 25px;
    width: 100%;
    list-style: none;
    padding: 0;
    margin-bottom: 0;
`;

export const ParticularLi = styled('ul', { label: 'ParticularLi' }) <{ isSelected: boolean }>`
    flex-direction: row;
    margin-left: 0;
    border-bottom: 5px solid ${({ isSelected }): string => isSelected ? pepAndSanctionsColors.borderBottomColorSelected : pepAndSanctionsColors.oddTableColor};
    transition: ${({ isSelected }): string => isSelected ? 'none' : 'all 0.5s'};
    font-family: Lato, sans-serif;
    font-weight: 300;
    cursor: pointer;
    color: ${({ isSelected }): string => isSelected ? pepAndSanctionsColors.mainColor : pepAndSanctionsColors.liColor};
    font-weight: bold;
`;

export const Header = styled('h1', { label: 'Header' })`
    margin-top: 32px;
    font-size: 24px;
`;

export const ActionSelect = styled('div', { label: 'ActionSelect' })`
    width: fill-available;
    height: fill-available;
    margin: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    font-family: inherit;
    font-size: 12px;
    transition: all 150ms ease;

    &:focus {
        outline: none;
    }
`;

export const DropdownActionPlaceholder = styled('div', { label: 'DropdownActionPlaceholder' })`
    width: fill-available;
    margin: -14px 0;
    padding: 14px;
    position: relative;
    background: transparent;
    color: ${pepAndSanctionsColors.txtColor};
    font-size: 12px;
`;

export const DropdownULAction = styled('ul', { label: 'DropdownULAction' })`
    position: absolute;
    padding: 0;
    border-radius: 4px !important;
    overflow:hidden;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
    font-weight: bold;
    z-index: 10000;
    margin-left: 0;
    margin-top: 18px;
    calc(100% - 8px);
`;

export const LiNotSelectedAction = styled('li', { label: 'LiNotSelectedAction' })`
    position: relative;
    padding: 4px 8px 4px 8px;
    width: fill-available;
    height: 32px;
    font-size: 12px;
    background: ${pepAndSanctionsColors.oddTableColor};
    cursor: pointer;
    list-style: none;
    z-index: 10000;
    display: flex;
    align-items: center;
`;

export const ChevronDownWrapper = styled(ChevronDownIcon, { label: 'ChevronDownWrapper' })`
    fill: ${pepAndSanctionsColors.txtColor};
    margin: 8px 8px;
    right: 6px;
    position: absolute;
    pointer-events: none;
`;

export const ButtonWrapper = styled(Button, { label: 'ButtonWrapper' })`
    margin: auto;
`;

export const ListedTitles = styled('ul', { label: 'ListedTitles' })`
    list-style: none;
    padding: 0;
`;

